module.exports = __webpack_public_path__ + "static/rightClick@2x-fb5f39a5ddf709ce3339c9968859d072.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/rightClick@2x.png
// module id = 2592
// module chunks = 168707334958949